var React = require('react');

function Inbox (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},[React.createElement("path",{"stroke":"none","d":"M0 0H16V16H0z","key":0}),React.createElement("g",{"strokeLinecap":"round","strokeLinejoin":"round","key":1},React.createElement("path",{"d":"M4.5 5.5L11.5 5.5M4.5 8.5L11.5 8.5M15.5 7C15.5 3.41 12.142.5 8 .5 3.858.5.5 3.41.5 7s3.358 6.5 7.5 6.5c.525 0 1.037-.048 1.532-.137L13.5 15.5v-4.091c1.238-1.159 2-2.705 2-4.409z"}))]));
}

Inbox.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16"};

module.exports = Inbox;

Inbox.default = Inbox;
